<template>
  <div class="scroll-wrapper">
    <div class="certificates-list">
      <div class="flex justify-between items-center mb-4">
        <el-button type="primary" @click="openDialog">Добавить сертификат</el-button>
      </div>

    <el-table :data="certificates" style="width: 100%">
      <el-table-column prop="title" label="Название" />
      <el-table-column prop="amount" label="Номинал" />
      <el-table-column prop="duration_months" label="Срок (мес)" />
      <el-table-column prop="comment" label="Комментарий" />
      <el-table-column label="Действия" width="140">
        <template #default="scope">
          <el-button size="small" :icon="EditPen" @click="editCertificate(scope.row)" />
          <el-button size="small" :icon="Delete" type="danger" @click="deleteCertificateAction(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

      <el-dialog v-model="dialogVisible" :title="isEdit ? 'Редактировать сертификат' : 'Новый сертификат'">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="auto">
        <el-form-item label="Название" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="Номинал" prop="amount">
          <el-input-number v-model="form.amount" :min="1" />
        </el-form-item>
        <el-form-item label="Срок действия (мес)" prop="duration_months">
          <el-input-number v-model="form.duration_months" :min="1" />
        </el-form-item>
        <el-form-item label="Комментарий">
          <el-input v-model="form.comment" type="textarea" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="submitForm">Сохранить</el-button>
      </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Delete, EditPen } from '@element-plus/icons-vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CertificatesList',
  computed: {
    ...mapState('certificates', ['certificates']),
    Delete() {
      return Delete
    },
    EditPen() {
      return EditPen
    }
  },
  data() {
    return {
      dialogVisible: false,
      isEdit: false,
      form: this.getEmptyForm(),
      editingId: null,
      rules: {
        title: [{ required: true, message: 'Введите название сертификата', trigger: 'blur' }],
        amount: [{ required: true, message: 'Укажите номинал', trigger: 'blur' }],
        duration_months: [{ required: true, message: 'Укажите срок действия', trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapActions('certificates', [
      'fetchCertificates',
      'saveCertificate',
      'updateCertificate',
      'deleteCertificate'
    ]),
    getEmptyForm() {
      return {
        title: '',
        amount: 0,
        duration_months: 12,
        comment: ''
      }
    },
    openDialog() {
      this.form = this.getEmptyForm()
      this.isEdit = false
      this.dialogVisible = true
      this.editingId = null
    },
    editCertificate(cert) {
      this.form = { ...cert }
      this.isEdit = true
      this.editingId = cert.id
      this.dialogVisible = true
    },
    deleteCertificateAction(cert) {
      this.$confirm(
        `Удалить сертификат "${cert.title}"?`,
        'Подтверждение удаления',
        {
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          type: 'warning',
        }
      ).then(() => {
        this.deleteCertificate(cert.id)
      }).catch(() => {
        // ничего не делаем при отмене
      })
    },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (this.isEdit && this.editingId !== null) {
          this.updateCertificate({ id: this.editingId, ...this.form })
        } else {
          this.saveCertificate(this.form)
        }
        this.dialogVisible = false
      })
    }
  },
  mounted() {
    this.fetchCertificates()
  }
}
</script>

<style scoped>
.certificates-list {
  padding: 20px;
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}
</style>
